import axios from "axios";
import { PromiseHandler } from "../../handlers";
import { eligibilityCriteriaFromService } from "../../models/experiments";
class EligibilityCriteria extends PromiseHandler {
    constructor(sdk) {
        super(sdk, "eligibility-criteria", { atomize: true });
        this.delete = async (id) => {
            return this.deleteItem(id).then((archived) => {
                this.cache.reconcile("save", archived);
                return archived;
            });
        };
        this.url = `${this.sdk.urls.baseAPIUrl}/eligibility-criteria`;
    }
    async findItems() {
        return this.cache.promise(this.url, () => axios
            .get(this.url, {
            headers: { "Content-Type": "application/json" }
        })
            .then(({ data: res }) => (res.data || []).map(eligibilityCriteriaFromService)));
    }
    async saveItem(criteria) {
        // Hand-rolled rather than eligibilityCriteriaToService: this endpoint is create-only, so the
        // payload must never carry an id (unlike that mapper, used where an existing criteria's id is needed).
        return axios
            .post(this.url, {
            name: criteria.name,
            min_budget: criteria.minBudget,
            max_budget: criteria.maxBudget,
            min_duration_days: criteria.minDurationDays,
            max_duration_days: criteria.maxDurationDays,
            min_impression_goal: criteria.minImpressionGoal,
            max_impression_goal: criteria.maxImpressionGoal,
            min_pacing_horizon_pct: criteria.minPacingHorizonPct,
            allowed_pacing_modes: criteria.allowedPacingModes,
            allowed_billing_types: criteria.allowedBillingTypes,
            allowed_inventory_sources: criteria.allowedInventorySources,
            allowed_media_sub_types: criteria.allowedMediaSubTypes
        }, { headers: { "Content-Type": "application/json" } })
            .then(({ data: res }) => eligibilityCriteriaFromService(res.data));
    }
    async deleteItem(id) {
        return axios
            .post(`${this.url}/${id}/archive`, null, {
            headers: { "Content-Type": "application/json" }
        })
            .then(({ data }) => {
            if (data.status !== "OK")
                throw new Error(`Archive failed: ${data.status}`);
            return { id, archived: true };
        });
    }
}
export default EligibilityCriteria;
//# sourceMappingURL=index.js.map